<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    created() {
      if (this.$cookie.get('ONLINEFLAG') === "ONLINE") {
        this.$router.push(this.$startPath);
      } else {
        // try {
        //   let url = window.location.href;
        //   let param = url.split('?')[1];
        //   let ac = param.split('&')[0].split('=')[1];
        //   let pw = param.split('&')[1].split('=')[1];
        //   this.$router.push('/Main?ac=' + ac + '&pw=' + pw + '"');
        // }
        // catch {
        //   this.$router.push("/Login");
        // }
      }
    }
  }
</script>